import React, { useEffect, useState } from 'react'
import {
    Card,
    CardContent,
    TextField,
    Button,
    Box,
    Typography,
    CircularProgress
} from '@material-ui/core'
import AuthService from 'tools/AuthService'
import { getUnderwritingSettings, updateUnderwritingSettings } from 'actions/underwriterDashboard'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'

const UnderwritingForm = () => {
    const client = AuthService.loggedInUser?.securityContext?.client || {}
    const [slaHours, setSlaHours] = useState(client.decisionSlaHours || 24)
    const [saving, setSaving] = useState(false)

    // Load latest settings from the server so the form reflects DB state even if
    // the in-memory client object is stale.
    useEffect(() => {
        getUnderwritingSettings()()
            .then(res => {
                const v = res?.response?.decisionSlaHours ?? res?.decisionSlaHours
                if (v) setSlaHours(v)
            })
            .catch(() => { /* fall back to the value from securityContext */ })
    }, [])

    const handleChange = (e) => {
        const v = parseInt(e.target.value, 10)
        setSlaHours(Number.isNaN(v) ? '' : v)
    }

    const handleSave = async () => {
        if (!slaHours || slaHours <= 0) {
            Toast({ type: 'error', message: strings.UD_SETTINGS.SLA_INVALID })
            return
        }
        setSaving(true)
        try {
            await updateUnderwritingSettings({ decisionSlaHours: slaHours })()
            // Reflect the change immediately on the client object in AuthService so the
            // dashboard picks up the new SLA without requiring a relogin.
            AuthService.loggedInUser = {
                ...AuthService.loggedInUser,
                securityContext: {
                    ...AuthService.loggedInUser.securityContext,
                    client: { ...client, decisionSlaHours: slaHours }
                }
            }
            Toast({ type: 'success', message: strings.UD_SETTINGS.SAVE_SUCCESS })
        } catch (e) {
            Toast({ type: 'error', message: strings.UD_SETTINGS.SAVE_ERROR })
        } finally {
            setSaving(false)
        }
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" style={{ marginBottom: 8 }}>
                    {strings.UD_SETTINGS.TITLE}
                </Typography>
                <Typography variant="body2" style={{ color: 'var(--fg-tertiary)', marginBottom: 24 }}>
                    {strings.UD_SETTINGS.DESCRIPTION}
                </Typography>
                <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                    <TextField
                        label={strings.UD_SETTINGS.SLA_LABEL}
                        type="number"
                        value={slaHours}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        inputProps={{ min: 1, max: 720 }}
                        style={{ width: 350 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        disabled={saving}
                        startIcon={saving ? <CircularProgress size={14} /> : null}
                    >
                        {strings.UD_SETTINGS.SAVE}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    )
}

export default UnderwritingForm
